// #region imports
import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
// #endregion

const MuiDialog = {
  styleOverrides: {
    paper: ({ theme }: { theme: Theme}) => ({
      '& .MuiButton-root': {
        fontSize: 16,
        lineHeight: 1.375
      },
      '& .modalFooter': {
        padding: '0 12px 12px',
        fontSize: 15,
        lineHeight: '21px',
        [theme.breakpoints.up('md')]: {
          padding: '0 24px 24px'
        }
      }
    }),
    paperFullWidth:  ({ theme }: { theme: Theme}) => ({
      margin: 0,
      boxShadow: 'none',
      borderRadius: '30px 30px 0 0',
      width: '100%',
      marginTop: 'auto',
      maxHeight: '100%',
      maxWidth: 620,
      overflow: 'visible',
      '& form': {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1
      },
      [theme.breakpoints.up('md')]: {
        height: 'auto',
        margin: 20,
        width: 'calc(100% - 40px)',
        maxHeight: 'calc(100% - 40px)',
        minHeight: 254,
        borderRadius: 30
      },
      '& .modalCloseIcon': {
        fontSize: 17,
        position: 'absolute',
        top: -35,
        right: 0,
        color: theme.palette.common.white,
        [theme.breakpoints.up('md')]: {
          fontSize: 30,
          top: -50
        }
      }
    }),
    paperFullScreen : {
      maxWidth: 'none',
      maxHeight: 'none',
      margin: 0,
      width: '100%',
      borderRadius: 0
    }
  }
} as Components['MuiDialog'];

export default MuiDialog;
